<template>
  <note-list
    :is-fetching="uiFlags.isFetching"
    :notes="notes"
    @add="onAdd"
    @delete="onDelete"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import NoteList from './components/NoteList';
import TicketNotesAPI from 'dashboard/api/ticketNotes';

export default {
  components: {
    NoteList,
  },
  props: {
    contactId: {
      type: Number,
      required: false,
      default: null,
    },
    isTicket: {
      type: Boolean,
      default: false
    },
    ticket: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters({ uiFlags: 'contactNotes/getUIFlags' }),
    notes(){
      if (this.isTicket && !this.contactId) {
        return this.ticketNotes;
      }

      const listNotes = this.$store.getters['contactNotes/getAllNotesByContact'](this.contactId);
      if(!this.isTicket){
        return listNotes.filter((note) => note.ticket_id == null ||  note.ticket_id == 0);
      }
      return listNotes.filter((note) => note?.ticket_id == this.ticket?.id);
    },
  },
  mounted() {
    this.fetchContactNotes();
  },
  data() {
    return {
      ticketNotes: [],
    };
  },
  methods: {
    fetchContactNotes() {
      const { contactId } = this;
      if (this.isTicket && !contactId) {
        this.fetchTicketNotes();
        return;
      }
      if (contactId) this.$store.dispatch('contactNotes/get', { contactId });
    },
    async fetchTicketNotes() {
      if (!this.ticket?.id) return;
      const { data } = await TicketNotesAPI.get(this.ticket.id);
      this.ticketNotes = data;
    },
    onAdd(note) {
      const { contactId, isTicket, ticket } = this;

      if (isTicket && !contactId) {
        this.onAddTicketNote(note);
        return;
      }

      const payload = {
        content: note.content, 
        file: note.file,
        contactId
      }

      if(isTicket){
        payload.ticket_id = ticket.id;
      }
      this.$store.dispatch('contactNotes/create', payload).then(() => this.$emit('created'));
    },
    async onAddTicketNote(note) {
      if (!this.ticket?.id) return;
      const { data } = await TicketNotesAPI.create(this.ticket.id, note.content, note.file);
      this.ticketNotes = [...this.ticketNotes, data];
      this.$emit('created');
    },
    onDelete(noteId) {
      const { contactId } = this;
      if (this.isTicket && !contactId) {
        this.onDeleteTicketNote(noteId);
        return;
      }
      this.$store.dispatch('contactNotes/delete', { noteId, contactId });
    },
    async onDeleteTicketNote(noteId) {
      if (!this.ticket?.id) return;
      await TicketNotesAPI.delete(this.ticket.id, noteId);
      this.ticketNotes = this.ticketNotes.filter(n => n.id !== noteId);
    },
  },
};
</script>
